// 🚨 AUTO-GENERADO desde SettlementPaymentDataType.ts - No editar manualmente

export const SettlementPaymentFormDataKeys = [
  "id",
  "descripcion",
  "monto",
  "vuelto",
  "formaPago",
  "digitosTarjeta",
  "numAprobacion",
  "estado",
  "exchangeRate",
  "created",
  "user",
  "recibeId",
  "recibe",
  "currencyId",
  "currency",
  "bankAccountId",
  "bankAccount",
  "creditOperatorId",
  "creditOperator",
  "settlementId",
  "settlement"
] as const;
